<div class="comment-item pt-05" [class.divider-bottom]="showDivider">
  <div class="comment-header">
    <app-user-card [user]="comment.createdBy" [showMenu]="false" [wrap]="false"></app-user-card>
    <span class="comment-date">{{ comment.created | date: dateTimeFormat }}</span>
  </div>
  @if (userAccess(); as userAccess) {
    @if (!comment.isDomainComment) {
      <div class="comment-item-actions">
        @if (
          isPOMode ||
          hasAdminPrivilege ||
          (canEditOwnComment && userAccess.id === comment.createdBy.id)
        ) {
          <app-ui-button
            (click)="editComment()"
            [disabled]="(updateAction | actionInProgress | async) === true"
            class="edit-button m-0 small-icon"
            buttonType="icon-button"
            iconVariant="legacy"
            [privilege]="privilege"
            [adminPrivilege]="adminPrivilege"
            icon="edit"
          ></app-ui-button>
        }
        @if (
          showDeleteButton &&
          (isPOMode ||
            hasAdminPrivilege ||
            (canDeleteOwnComment && userAccess.id === comment.createdBy.id))
        ) {
          <app-ui-button
            appConfirmDialog
            [disabled]="(deleteAction | actionInProgress | async) === true"
            [content]="deleteCommentMsg"
            (confirmed)="deleteComment(comment.id)"
            class="delete-button m-0 small-icon"
            buttonType="icon-button"
            iconVariant="legacy"
            [privilege]="privilege"
            [adminPrivilege]="adminPrivilege"
            icon="close"
          ></app-ui-button>
        }
      </div>
    }
  }

  @if (!isEditMode) {
    <div
      class="comment-text"
      [class.pb-1]="!comment.attachments?.length"
      [innerHTML]="comment.content | mentionLink: comment.mentionedUsers"
    ></div>
    @if (comment.attachments?.length) {
      <div class="comment-attachments" (click)="openAttachmentsDialog()">
        <app-ui-button
          class="m-0 small-icon"
          buttonType="icon-button"
          iconVariant="legacy"
          icon="attach_file"
        ></app-ui-button>
        {{ comment.attachments.length }} {{ 'attachments' | translate }}
      </div>
    }
  }

  @if (isEditMode) {
    <app-comment-input
      [entityId]="entityId"
      [entityType]="entityType"
      [privilege]="privilege"
      [comment]="comment"
      [isInPopup]="isInPopup"
      (editCancelled)="cancelEdit()"
    ></app-comment-input>
  }
</div>

<ng-template #deleteCommentMsg>
  <p>{{ 'areYouSureYouWantToDeleteThisComment' | translate }}</p>
</ng-template>
